export type Status =
  | "wip"
  | "live"
  | "stable"
  | "experimental"
  | "unstable"
  | "abandoned"
  | "deprecated"
  | "cursed"
  | "archived"
  | "frozen";

export const STATUS_META: Record<Status, { color: string; label_en: string; label_jp: string }> = {
  live:         { color: "#4cff91", label_en: "Live",         label_jp: "公開中" },
  stable:       { color: "#00cfff", label_en: "Stable",       label_jp: "安定版" },
  wip:          { color: "#ffb800", label_en: "WIP",          label_jp: "制作中" },
  experimental: { color: "#ff8c00", label_en: "Experimental", label_jp: "実験的" },
  unstable:     { color: "#ff4444", label_en: "Unstable",     label_jp: "不安定" },
  abandoned:    { color: "#888888", label_en: "Abandoned",    label_jp: "放棄" },
  deprecated:   { color: "#666666", label_en: "Deprecated",   label_jp: "非推奨" },
  cursed:       { color: "#c084fc", label_en: "Cursed",       label_jp: "呪われた" },
  archived:     { color: "#444444", label_en: "Archived",     label_jp: "アーカイブ" },
  frozen:       { color: "#606075", label_en: "Frozen",       label_jp: "凍結" },
};
